import 'bootstrap';
import "../scss/app.scss";
import "../js/modernizr";
import "../js/slick.min";
import $ from "jquery";
window.jQuery = $;
window.$ = $;
$(function () {
    $(".no-js").removeClass("no-js").addClass("js");
    if ($(document).scrollTop() >= 10) {
        $("html").addClass("scrolled");
    }
    $(document).scroll(function () {
        if ($(document).scrollTop() >= 10) {
            $("html").addClass("scrolled");
        } else {
            $("html").removeClass("scrolled");
        }
        // quickLinks();
    });

    //Quick-links
    // let quicklinks = $(".quick-links"),
    //     quickLinksClone = quicklinks.clone();
    // $("body").append('<div class="quick-links quick-links-clone"></div>');
    // let quicklinksClone = $(document).find(".quick-links-clone");
    // quicklinksClone.append(quickLinksClone);
    // function quickLinks() {
    //     let quicklinksHeight = quicklinks.height(),
    //         quickLinksShowPoint = 35;
    //     $("footer").css("padding-bottom", quicklinksHeight);

    //     if ($(document).height() > $(window).height()) {
    //         if ($(document).scrollTop() >= quickLinksShowPoint) {
    //             quicklinksClone.addClass("visible");
    //         } else {
    //             quicklinksClone.removeClass("visible");
    //         }
    //     } else {
    //         quicklinksClone.addClass("visible");
    //     }
    // }
    // quickLinks();

    //Home header
    function mobileHeaderHeight() {
        $("html:not(.desktop) .home header").css("height", window.innerHeight);
    }
    // mobileHeaderHeight();

    //*****************************
    // Mobile menu
    //******************************
    let menuTrigger = $(".js-menu-trigger"),
        menuTriggerHeight = menuTrigger.outerHeight(),
        brandingHeight = $(".branding").outerHeight(),
        nav = $("nav ul");
    //menuTrigger.css("top", (brandingHeight - menuTriggerHeight) / 2);
    menuTrigger.on("click", function (e) {
        $(this).toggleClass("open");
        $("html").toggleClass("menu-open");
        $("nav").toggleClass("u-hide-tablet-down");
        nav.toggleClass("expanded");
        // if ($(this).hasClass("open")) {
        //     text.text("Close menu");
        // } else {
        //     text.text("Open menu");
        // }

        e.preventDefault();
    });

    ///*****************************
    // Events list
    //******************************

    $(".events-list").each(function(){
        let $t = $(this),
        $totalEvents = $t.children("li:not(.month)").length,
        $maxVisible = 19,
        $thirdMonth = $t.children("li.month:eq(2)");
        if($thirdMonth){
            let $remainder = $totalEvents - $thirdMonth.index();
            if($remainder > 8){
                $thirdMonth.before(`
                    <li class="show-all"><button class="show-all-events">Show all `+$totalEvents+` events</button></li>
                    `).hide().nextAll("li").hide();
            }
        }
        // alert($thirdMonth.index())
        // $t.attr("data-total", $totalEvents);
        // if($totalEvents - $maxVisible > 10) {
        //     $t.children("li:gt("+($maxVisible - 1)+")").hide();
        //     $t.children("li:eq("+($maxVisible - 1)+")").after(`
        //     <li class="show-all"><button class="show-all-events">Show all `+$totalEvents+` events</button></li>
        //     `)
        // }
        $t.on("click", "button.show-all-events", function(){
            $(this).parent("li").remove()
            $t.children("li:not(:visible)").fadeIn()
        })
    })

    //*****************************
    // Notice
    //******************************
    let notice = $(".notice"),
        noticeClose = notice.find(".notice-close");
    if (notice.length) {
        $("html").addClass("overlay");

        noticeClose.on("click", function(e) {
            notice.fadeOut();
            $("html").removeClass("overlay");
            document.cookie = "notice=closed";
            e.preventDefault();
        });
    }

    //*****************************
    // Accordion
    //*****************************
    $(".accordion-header").addClass("clickable").next(".accordion-content").hide();

    $(document).find(".accordion-header.clickable").each(function(){
        let $t = $(this), 
        $text = $t.text();
        $t.text("Show "+$text);
        $t.on("click", function(){
            $t.toggleClass("active").next(".accordion-content").slideToggle();
            if($t.hasClass("active")){
                $t.text("Hide "+$text)
            }else{
                $t.text("Show "+$text)
            }
        })
    })
    

    //*****************************
    // Tabbordion
    //*****************************
    $(".tabbordion").each(function () {
        let $t = $(this);
        $t.prepend('<ul class="tabbordion-tabs"></ul>');
        $t.find(".tabbordion-item-header").each(function (index) {
            let tabTitle = $(this).text(),
                tabID = "tabbordion-item-" + (index + 1);
            $(this).addClass("accordion-mode hide-desktop").attr({
                "aria-selected": "false",
                "aria-controls": tabID
            });
            $(function () {
                $t.find(".tabbordion-tabs").append(
                    "<li aria-selected=false aria-controls='" +
                        tabID +
                        "'" +
                        "><button>" +
                        tabTitle +
                        "</button></li>"
                );
            });
        });
        $(function () {
            $t.find(".tabbordion-item").each(function () {
                let ariaID = $(this)
                    .find(".tabbordion-item-header")
                    .attr("aria-controls");
                $(this).addClass(ariaID);
            });
            $t.find(".tabbordion-item-content").addClass("hide-mobile");
            $t.find(".tabbordion-item:gt(0)").addClass("hide-desktop");
            $t.find(".tabbordion-tabs li:first")
                .addClass("active")
                .attr("aria-selected", "true");
        });
    });
    //Accordion mode
    $(function () {
        $(".tabbordion-item-header").on("click", function () {
            $(this).next(".tabbordion-item-content").toggleClass("hide-mobile");
            if ($(this).attr("aria-selected") == "true") {
                $(this).attr("aria-selected", false);
            } else {
                $(this).attr("aria-selected", true);
            }
        });
    });

    //Tab mode
    $(function () {
        $(".tabbordion-tabs li").on("click", function () {
            let tabToOpen = $(this).attr("aria-controls"),
                thisAccordion = $(this).parents(".tabbordion");
            if ($(this).attr("aria-selected") == "false") {
                thisAccordion
                    .find("[aria-selected='true']")
                    .attr("aria-selected", false);
                thisAccordion.find(".tabbordion-item").addClass("hide-desktop");
                $(this).attr("aria-selected", true);
                thisAccordion.find("." + tabToOpen).removeClass("hide-desktop");
            }
        });
    });

    //*****************************
    // Show in next row panels
    //*****************************
    $(".show-in-next-row-panel").each(function () {
        let $t = $(this);
        $t.addClass("collapsable")
            .find(".show-in-next-row-panel-item-header")
            .wrap('<a class="show-in-next-row-panel-item-trigger" href="#">');
        $(function () {
            let trigger = $t.find(".show-in-next-row-panel-item-trigger");
            trigger.on("click", function (e) {
                trigger.each(function () {
                    let triggerOffset = $(this).offset().top;
                    $(this).attr("data-top", triggerOffset);
                });
                let panelContent = $(this)
                        .parents(".show-in-next-row-panel-item")
                        .find(".show-in-next-row-panel-item-content")
                        .html(),
                    clickOffset = $(this).attr("data-top");
                if (!$(this).hasClass("panel-open")) {
                    $(".panel-open").removeClass("panel-open");
                    $(".panel-active").removeClass("panel-active");
                    $(".panel-inactive").removeClass("panel-inactive");
                    $(".show-in-next-row-panel-reveal-content").remove();
                    $(this)
                        .addClass("panel-open")
                        .parent(".show-in-next-row-panel-item")
                        .addClass("panel-active")
                        .siblings()
                        .addClass("panel-inactive");

                    // setTimeout(function () {
                    //     let activePanel = $(document).find(".panel-active");
                    //     $("html,body").animate(
                    //         {
                    //             scrollTop:
                    //                 activePanel.offset().top;
                    //         },
                    //         500
                    //     );
                    // }, 500);

                    $("[data-top='" + clickOffset + "']:last")
                        .parents(".show-in-next-row-panel-item")
                        .after(
                            '<div class="show-in-next-row-panel-reveal-content">' +
                                panelContent +
                                "</div>"
                        )
                        .next(".show-in-next-row-panel-reveal-content")
                        .hide()
                        .fadeIn();
                } else {
                    $(this).removeClass("panel-open");
                    $(".panel-active").removeClass("panel-active");
                    $(".panel-inactive").removeClass("panel-inactive");
                    $(".show-in-next-row-panel-reveal-content").remove();
                }
                $(this).blur();
                e.preventDefault();
            });
        });
    });

    let WindowWidth = $(window).outerWidth(),
        WindowHeight = $(window).outerHeight();
    if (WindowWidth > 1024) {
        $("html").addClass("desktop");
        $(".home header").css("height", "");
    }

    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    // if ($("body.home").length) {
    //     $("header").css("height", WindowHeight);
    // }
    //console.log(WindowWidth);

    //*****************************
    // Window resize event
    //*****************************
    window.addEventListener("resize", function () {
        let ResizeWindowWidth = $(window).outerWidth(),
            ResizeWindowHeight = $(window).outerHeight();
        //console.log(ResizeWindowWidth);

        if (ResizeWindowWidth > 1024) {
            $("html").addClass("desktop");
            $(".home header").css("height", "");
        } else {
            $("html").removeClass("desktop");
            if ($(".js-menu-trigger.open").length) {
                $(".js-menu-trigger.open").trigger("click");
            }
        }
        if ($(".show-in-next-row-panel").length) {
            $("html.desktop .show-in-next-row-panel-reveal-content").remove();
            $("html.desktop .panel-open").removeClass("panel-open");
            $(
                "html.desktop .show-in-next-row-panel-item.panel-inactive"
            ).removeClass("panel-inactive");
        }
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
        // if ($("body.home").length) {
        //     $("header").css("height", ResizeWindowHeight);
        // }
    });

    //*****************************
    // Carousels
    //*****************************

    //$(".carousel").slick();

    $(".image-carousel").slick({
        arrows: false,
        centerMode: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 6000,
        speed: 1000,
        infinite: true,
        pauseOnHover: false,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                fade: false,
                autoplaySpeed: 3000,
                centerMode: true
              }
            }
        ]

    });

    $(".carousel-inner").slick({
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 6000,
        speed: 1000,
        infinite: true,
        pauseOnHover: false,
    });

    //*****************************
    // Styled dropdowns
    //*****************************
    $("select").each(function () {
        let $t = $(this),
            option = $t.find("option");
        $t.wrap('<div class="styled-dropdown"></div>').before(
            "<ul class='dropdown-collapsed'></ul>"
        );
        option.each(function () {
            let optionValue = $(this).attr("value"),
                optionLabel = $(this).text();
            $(this)
                .parents(".styled-dropdown")
                .find("ul")
                .append(
                    "<li data-value=" +
                        optionValue +
                        ">" +
                        optionLabel +
                        "</li>"
                );
        });
    });
    $(document).on("click", ".styled-dropdown li", function (e) {
        let $t = $(this),
            itemValue = $t.attr("data-value");
        if ($t.parents(".dropdown-collapsed").length > 0) {
            //currently collapsed, so open dropdown
            $t.parents(".dropdown-collapsed").removeClass("dropdown-collapsed");
        } else {
            //not collapsed, so do stuff
            let cloned = $t.clone(),
                dropdown = $t.parents(".styled-dropdown");
            dropdown.find("option[selected]").removeAttr("selected");
            dropdown
                .find("option[value=" + itemValue + "]")
                .attr("selected", "");
            $t.parents("ul").addClass("dropdown-collapsed").prepend(cloned);
            $t.remove();
        }
        e.preventDefault();
    });

    AOS.init();

    $(document).on("click","[data-toggle-element]", function(){
        let $target = $(this).attr("data-toggle-element")
        $($target).toggle()

    })

    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        let $headerHeight = $(".branding-nav").outerHeight();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - $headerHeight - 5
        }, 1000);
    });

    if(window.location.hash) {
        let $hash = window.location.hash,
        $headerHeight = $(".branding-nav").outerHeight();
        if($($hash)){
            $("html,body").animate({ scrollTop: $($hash).offset().top - 5 - $headerHeight }, 1200);
        }
      }


});

// console.log("all done!");
